import React from "react";
import { connect } from "react-redux";
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { deletePose } from '../../store/actions/poseActions'
import { NavLink } from 'react-router-dom'

const AllPosesAdmin = (props) => {

    const poses = props.poses || [];

    const poseList  = poses.length ? (poses.map(pose => {
      return (
        <tr key={pose.id}>
          <td>{pose.name}</td>
          <td>{pose.description}</td>
          <td>{pose.types.join(', ')}</td>
          <td>{pose.level}</td>
          <td><NavLink to={`/admin/poses/${pose.id}/edit`}><i className="material-icons blue-text right">edit</i></NavLink></td>
          <td><i className="material-icons red-text right" onClick={() => props.deletePose(pose.id)}>delete</i></td>
        </tr>
      )
    })
    ) : (
      <tr>
        <td>No pose to display.</td>
      </tr>
    )

    return (
      <table className="highlight">
        <thead>
          <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Types</th>
              <th>Level</th>
              <th>Edit</th>
              <th>Delete</th>
          </tr>
        </thead>
        <tbody>{poseList}</tbody>
      </table>
    )
  
}


const mapStateToProps = (state) => {
  return {
    poses: state.firestore.ordered.poses
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deletePose: (id) => dispatch(deletePose(id))
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect([
    { collection: 'poses' }
  ])
)(AllPosesAdmin)
